const ProfileAvailability = {
  mixins: [ProfileValidation],
  computed: {
    canOnline() {
      return this.profile.activities.some((activities) => activities.online);
    },
    week() {
      return (this.schedules || []).filter(
        (av) => av._id.indexOf('week.') === 0,
      );
    },
    weekend() {
      return (this.schedules || []).filter(
        (av) => av._id.indexOf('weekend.') === 0,
      );
    },
    ...Vuex.mapState(['signup', 'profile', 'schedules', 'availability']),
  },
  mounted() {
    if (!this.signup) {
      this.$v.profile.$touch();
    }
  },
  template: `
      <div>
      <template v-if="profile.type ==='P'">
        <h3>Disponibilidad</h3>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-1">
            <ul class="uk-list">
              <li 
                v-for="av in availability"
                v-if="!(av._id === 'availability.online' && !canOnline)"
              >
                <label>
                  <input
                      :value="av._id"
                      type="checkbox"
                      class="uk-checkbox"
                      v-model="profile.availability"
                  > {{ av.name }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </template>
        
      <div class="uk-grid uk-grid-small uk-child-width-1-2@m uk-margin-medium-top">
        <div>
          <h3>Semana laboral</h3>
          <ul class="uk-list">
            <li v-for="av in week">
              <label>
                <input
                    :value="av._id"
                    type="checkbox"
                    class="uk-checkbox"
                    v-model="profile.schedules"
                > {{ av.name }}
              </label>
            </li>
          </ul>
        </div>
        <div>
          <h3>Fin de semana</h3>
          <ul class="uk-list">
            <li v-for="av in weekend">
              <label>
                <input
                    :value="av._id"
                    type="checkbox"
                    class="uk-checkbox"
                    v-model="profile.schedules"
                > {{ av.name }}
              </label>
            </li>
          </ul>
        </div>
      </div>
      <p
	      class="uk-alert uk-alert-danger"
	      v-if="$v.profile.schedules.$dirty && $v.profile.schedules.$invalid"
      >
        Debes rellenar este campo para poder publicar tu perfil
      </p>
      <div class="uk-text-right uk-margin-large-top uk-margin-large-bottom">
        <button v-if="!signup" @click="$parent.$emit('profile.save');" class="uk-button uk-button-dmtk">Guardar</button>
        <router-link v-if="signup" to="/notificaciones" class="uk-button uk-button-primary uk-button-bold">
          Siguiente
        </router-link>
      </div>
      </div>
	`,
};
